export default __webpack_public_path__ + "static/media/7.faf97853.jpg";